import { render, staticRenderFns } from "./phoneQuestionnaire.vue?vue&type=template&id=68fd4b42&scoped=true&lang=pug"
import script from "./phoneQuestionnaire.vue?vue&type=script&lang=js"
export * from "./phoneQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./phoneQuestionnaire.vue?vue&type=style&index=0&id=68fd4b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd4b42",
  null
  
)

export default component.exports